import React from 'react';
import VerticalNewBadge from 'assets/images/backoffice/capital/vertical-new-badge.png';
import DetailCard from './DetailCard';
import styles from './DetailCard.css';

function DetailInvestment() {
  return (
    <div className={styles['detail-term-loan']}>
      <img src={VerticalNewBadge} className={styles['investment-new-badge']} />
      <DetailCard title="Apa itu Moka Capital Investment?" border="green">
        <p className={styles['text-default']}>
          <b>Moka Capital</b> bekerja sama dengan <b>Santara</b> untuk
          memberikan fasilitas pendanaan modal usaha bagi pengguna Moka POS
          melalui sistem equity crowdfunding untuk tujuan pengembangan bisnis.
        </p>
      </DetailCard>
    </div>
  );
}

export default DetailInvestment;
